import { render, staticRenderFns } from "./BedroomSelectButton.vue?vue&type=template&id=6f5d387a&scoped=true&"
import script from "./BedroomSelectButton.vue?vue&type=script&lang=js&"
export * from "./BedroomSelectButton.vue?vue&type=script&lang=js&"
import style0 from "./BedroomSelectButton.vue?vue&type=style&index=0&id=6f5d387a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f5d387a",
  null
  
)

export default component.exports